import enUs from "./en-US.json";

import { initWithOnlyUseEnglish } from "shared/i18n/initWithOnlyUseEnglish";

initWithOnlyUseEnglish(enUs);
